import * as React from 'react';
import { Route } from 'react-router-dom';
import { factureSchema } from './facture';
import Main from '@app/main/tables/Main';

/**
 * Routes configurées pour le module Facture
 */
const FactureRoutes = [
    // Route de liste (principale)
    <Route
        key="factures-list"
        path="factures"
        element={<Main key="factures-main" pageConfig={factureSchema} />}
    />,
];

export default FactureRoutes;
